import { apiRequest } from './apiClient';
import {
  EMPTY_MAP_LABEL_STATE,
  normalizeMapLabelState,
} from '../utils/turkeyMapLabelPositions';

/**
 * Sunucudan harita etiket düzenini getirir.
 * @returns {Promise<typeof EMPTY_MAP_LABEL_STATE>}
 */
export async function fetchMapLabelState() {
  const response = await apiRequest('/api/map-labels', { method: 'GET' });
  const raw = response?.veri?.mapLabels ?? response?.veri ?? {};
  return normalizeMapLabelState(raw);
}

/**
 * Harita etiket düzenini sunucuya kaydeder.
 * @param {typeof EMPTY_MAP_LABEL_STATE} state
 */
export async function saveMapLabelState(state) {
  const payload = normalizeMapLabelState(state);
  const response = await apiRequest('/api/map-labels', {
    method: 'PUT',
    body: payload,
  });
  return response;
}

/**
 * Harita etiket düzenini sunucuda sıfırlar.
 */
export async function clearMapLabelState() {
  const response = await apiRequest('/api/map-labels', { method: 'DELETE' });
  return response;
}

export { EMPTY_MAP_LABEL_STATE };
